import * as React from 'react';

import { Button } from '../Button';
import { Form, FormSection, FormRow, FormField } from '../Form';
import { FormProgressIndicator } from '../FormProgressIndicator';
import { DateOfBirthInput } from '../DateOfBirthInput';
import { Text } from '../Text';
import { useFormState, areAllFieldsValid } from '../../hooks/form-state.js';

const maxChildren = 6;

// @ts-ignore
export const ApplicantsStep = (props) => {
  const [formState, actions] = useFormState({
    applicantDateOfBirth: {
      value: '',
      rule: (value: string) =>
        !value || Boolean(value.match(/^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/)),
    },
  });

  const isFormValid = areAllFieldsValid(formState);

  const childDateOfBirthFieldIds = [];
  let i = 0;

  // @ts-ignore
  while (formState[`child${i}DateOfBirth`] != null) {
    childDateOfBirthFieldIds.push(`child${i}DateOfBirth`);
    i += 1;
  }

  const showSpouse = (e: Event) => {
    e.preventDefault();

    // @ts-ignore
    actions.addField({
      spouseDateOfBirth: {
        value: '',
        rule: /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/,
      },
    });
  };

  const addChild = (e: Event) => {
    e.preventDefault();

    // @ts-ignore
    actions.addField({
      [`child${childDateOfBirthFieldIds.length}DateOfBirth`]: {
        value: '',
        rule: /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/,
      },
    });
  };

  return (
    <Form
      onSubmit={() => {
        if (!isFormValid) {
          // @ts-ignore
          actions.showAllValidationErrors();

          return;
        }

        props.onSubmit(
          Object.keys(formState).reduce((accum, fieldId) => {
            // @ts-ignore
            accum[fieldId] = formState[fieldId].value;

            return accum;
          }, {}),
        );
      }}
    >
      <FormSection>
        <div className="justify-center mb-6">
          <FormProgressIndicator
            steps={['Basics', 'Applicants', 'Quote']}
            currentStepIndex={1}
          />
        </div>
        <Text.H4>
          Tell us a little more about yourself and any dependents.
        </Text.H4>
      </FormSection>
      <FormSection>
        <FormRow>
          <FormField
            labelText="Primary Applicant Date of Birth"
            optional
            error={
              // @ts-ignore
              formState.applicantDateOfBirth.shouldShowValidationError
                ? 'Please enter a valid date of birth.'
                : ''
            }
          >
            <DateOfBirthInput
              onChange={(value: string) =>
                // @ts-ignore
                actions.setValue('applicantDateOfBirth', value)
              }
            />
          </FormField>
          <div className="w-full md:w-1/2" />
        </FormRow>

        {
          // @ts-ignore
          !!formState.spouseDateOfBirth && (
            <FormRow>
              <FormField
                labelText="Spouse Date of Birth"
                error={
                  // @ts-ignore
                  formState.spouseDateOfBirth.shouldShowValidationError
                    ? 'Please enter a valid date of birth.'
                    : ''
                }
              >
                <DateOfBirthInput
                  onChange={(value: string) =>
                    // @ts-ignore
                    actions.setValue('spouseDateOfBirth', value)
                  }
                />
              </FormField>
              <div className="w-full md:w-1/2">
                <FormField labelText="">
                  <Button
                    variant="SECONDARY"
                    size="LARGE"
                    type="button"
                    onClick={() =>
                      // @ts-ignore
                      actions.removeField('spouseDateOfBirth')
                    }
                  >
                    Remove Spouse
                  </Button>
                </FormField>
              </div>
            </FormRow>
          )
        }
        {childDateOfBirthFieldIds.map((fieldId, i) => (
          <FormRow key={fieldId}>
            <FormField
              labelText={`Child ${i + 1} Date of Birth`}
              error={
                // @ts-ignore
                formState[fieldId].shouldShowValidationError
                  ? 'Please enter a valid date of birth.'
                  : ''
              }
            >
              <DateOfBirthInput
                onChange={(value: string) =>
                  // @ts-ignore
                  actions.setValue(fieldId, value)
                }
              />
            </FormField>
            <div className="w-full md:w-1/2">
              {i === childDateOfBirthFieldIds.length - 1 && (
                <FormField labelText="">
                  <Button
                    variant="SECONDARY"
                    size="LARGE"
                    type="button"
                    onClick={() =>
                      // @ts-ignore
                      actions.removeField(fieldId)
                    }
                  >
                    Remove Child
                  </Button>
                </FormField>
              )}
            </div>
          </FormRow>
        ))}
        <FormRow>
          <div className="flex w-full flex-col md:flex-row justify-between md:mt-6 items-start">
            <div className="flex w-full justify-start space-x-2 mb-6 md:mb-0">
              <Button
                variant="SECONDARY"
                size="LARGE"
                onClick={showSpouse}
                // @ts-ignore
                disabled={!!formState.spouseDateOfBirth}
                type="button"
              >
                Add Spouse
              </Button>
              <Button
                variant="SECONDARY"
                size="LARGE"
                onClick={addChild}
                disabled={childDateOfBirthFieldIds.length >= maxChildren}
                type="button"
              >
                Add Child
              </Button>
            </div>
            <Button
              variant="PRIMARY"
              size="LARGE"
              is="input"
              type="submit"
              value="Continue"
            />
          </div>
        </FormRow>
      </FormSection>
    </Form>
  );
};
